import {
    applyHorizontalSpacing,
    HorizontalSpacing
} from '@styles/spacing-styles';
import { themeProvider } from '@swipejobs/frontend-theme-provider';
import { secureExternalLinkProps } from '@utils/secure-links';
import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Flexible = styled.div`
  flex: 1;
`;

export const Button = styled.button`
    min-width: 130px;
    min-height: 32px;
    max-height: 40px;
    border: ${() => themeProvider.getFraming().border.minimal};
    color: ${() => themeProvider.getColors().button.primaryButtonText};
    border-radius: ${() => themeProvider.getFraming().radius.small};
    box-shadow: 0 2px 5px 0 ${() => themeProvider.getColors().button.shadow};
    font-size: ${() => themeProvider.getTypography().font.size.large};
    font-family: ${() => themeProvider.getTypography().font.family.buttons};
    text-transform: ${() => themeProvider.getTypography().button.text.textTransform};
    
    &:hover {
        opacity: 0.8;
    }
    
    &:disabled {
      background-color: ${() => themeProvider.getColors().general.disabledColor};
    }
`;

interface ExpandingRowButtonProps extends HorizontalSpacing {
  limitExpansion?: boolean;
}

export const ExpandingRowButton = styled(Button)<ExpandingRowButtonProps>`
  min-width: 85px;
  max-width: 170px;
  flex: ${props => props.limitExpansion ? 0 : 1} 1 auto;
  ${props => applyHorizontalSpacing(props)};
`;

export const RejectRowButton = styled(ExpandingRowButton)`
    background-color: ${() => themeProvider.getColors().text.primaryTextColor};
    border: ${() => themeProvider.getFraming().border.tiny};
    border-color: ${() => themeProvider.getColors().text.errorTextMessage};
    color: ${() => themeProvider.getColors().text.errorTextMessage};
    
    &:disabled {
      border: ${() => themeProvider.getFraming().border.minimal};
      color: ${() => themeProvider.getColors().button.primaryButtonText};
    }
`;

export const ActionRowButton = styled(ExpandingRowButton)`
    background-color: ${() => themeProvider.getColors().general.primaryColor};
    color: ${() => themeProvider.getColors().text.primaryTextColor};
`;

export const ConfirmRowButton = styled(ExpandingRowButton)`
    background-color: ${() => themeProvider.getColors().general.greenDarkColor};
    color: ${() => themeProvider.getColors().text.primaryTextColor};
`;

export interface ExternalLinkProps {
    isolateLink?: boolean;
}

export const ExternalLink = styled.a.attrs<ExternalLinkProps>(secureExternalLinkProps)`
  color: ${() => themeProvider.getColors().general.primaryColor};
  text-decoration: none;
`;

export const ErrorLabel = styled.span`
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;
  min-height: 20px;
  color: ${() => themeProvider.getColors().text.errorTextMessage};
`;



// WEBPACK FOOTER //
// ./src/styles/shared-styles.tsx